// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__vps_j","main":"Layout_main__3OBIG","rotate":"Layout_rotate__1Dx4H","slideIn":"Layout_slideIn__1oSth","fadeIn":"Layout_fadeIn__1sRE9"};